export enum PayByLinkStatus {
    active = 'active',
    expired = 'expired',
    paid = 'paid',
    cancelled = 'cancelled',
    viewed = 'viewed',
    attempted = 'attempted',
    all = ''
}
